import React, { useState } from "react"
import {
  Card, CardContent, CardHeader,
  Typography, Box, Button,
  Tabs, Tab, Grid,
  Popover, IconButton,
  Paper, Divider
} from "@mui/material"
// import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker"
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { TemperatureChart } from "./temperature-chart"
import { HumidityChart } from "./humidity-chart"
import {
  Download as DownloadIcon,
  Print as PrinterIcon,
  Thermostat as ThermometerIcon,
  Opacity as DropletsIcon,
  LocationOn as MapPinIcon,
  AccessTime as ClockIcon,
  Info as InfoIcon,
  CalendarMonth as CalendarIcon
} from '@mui/icons-material'
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from "date-fns"
import { useAuth } from "../../Auth/AuthProvider"
import { useNavigate, useParams } from "react-router-dom"
import { can } from "../../Conections/LogConections"
import { DataTermometer, DatosConfTermometer, DatosTermometer } from "../../Conections/GreenhouseConection"
// import { es } from "date-fns/locale"

const sensorTem = {
  id: "",
  mac: "",
  lastUpdate: "2023-08-15 19:00",
  batteryLevel: "",
  status: "Activo",
  serial: "",
  firmwareVersion: "",
};

const sensorC = {
  id: "",
  conexion: "",
  clave: "",
};

export default function Termometerdashboard() {

  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();
  const { termometerid } = useParams();

  const [sampleData, setSampleData] = useState(
    {
      temperature: [],
      humidity: [],
      labels: [],
    }
  )
  const [activeView, setActiveView] = useState("daily")
  const [tabValue, setTabValue] = useState(0);
  const [sensor, setSensor] = useState(sensorTem);
  const [sensorConf, setSensorConf] = useState(sensorC);
  const today = new Date()
  const [dateRange, setDateRange] = useState({
    from: today,
    to: today,
  })

  React.useEffect(() => {
    async function reloaduser() {
      if (getToken()) {
        const permisionCan = await can(getToken(), getCompany(), "/greenhouse/showtermometer/:termometerid");
        if (permisionCan === 1) {
          let DataChart = await DatosTermometer(getToken(), getCompany(), termometerid);
          const sensorTem = {
            id: DataChart.id,
            mac: DataChart.mac,
            lastUpdate: "2023-08-15 19:00",
            batteryLevel: "87%",
            status: DataChart.enuso === 1 ? "Activo" : "Inctivo",
            serial: DataChart.serial,
            firmwareVersion: "V_" + DataChart.firmware.toString(),
          };
          setSensor(sensorTem);
          let TermometerConfig = await DatosConfTermometer(getToken(), getCompany(), termometerid);
          setSensorConf(TermometerConfig);
          let TermometerChart = await DataTermometer(getToken(), getCompany(), termometerid);
          setSampleData(TermometerChart);
        }
        else {
          goTo("/dashboard");
        }
      }
      else {
        goTo(`/login`);
      }
    };
    reloaduser();
  }, [termometerid, getCompany, getToken, goTo]);

  // Función para cambiar la vista y actualizar el rango de fechas
  const handleViewChange = (view) => {
    setActiveView(view)

    switch (view) {
      case "daily":
        setDateRange({ from: today, to: today })
        break
      case "weekly":
        setDateRange({
          from: startOfWeek(today, { weekStartsOn: 1 }),
          to: endOfWeek(today, { weekStartsOn: 1 }),
        })
        break
      case "monthly":
        setDateRange({
          from: startOfMonth(today),
          to: endOfMonth(today),
        })
        break
      default:
        break
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Modificar la función exportToExcel para que soporte diferentes formatos
  const exportData = (data, type, format) => {
    // Crear un array con los datos formateados
    const exportData = data.labels.map((label, index) => {
      if (type === "temperatura") {
        return {
          Hora: label,
          Temperatura: data.temperature[index],
        }
      } else {
        return {
          Hora: label,
          Humedad: data.humidity[index],
        }
      }
    })

    // Convertir a CSV
    const headers = Object.keys(exportData[0]).join(",")
    const csvRows = exportData.map((row) => Object.values(row).join(","))
    const csvContent = [headers, ...csvRows].join("\n")

    // Crear un blob y descargar
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.setAttribute("href", url)

    // Establecer el nombre del archivo según el formato
    const extension = format === "excel" ? "xlsx" : "csv"
    link.setAttribute("download", `${type}_datos.${extension}`)

    link.style.visibility = "hidden"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Agregar función para guardar la gráfica como imagen
  const saveChartAsImage = (elementId, fileName) => {
    const chartElement = document.getElementById(elementId)
    if (!chartElement) return

    const chartCanvas = chartElement.querySelector("canvas")
    if (!chartCanvas) return

    // Convertir el canvas a una URL de datos
    const imageUrl = chartCanvas.toDataURL("image/png")

    // Crear un enlace para descargar la imagen
    const link = document.createElement("a")
    link.download = `${fileName}.png`
    link.href = imageUrl
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Función para imprimir gráfica
  const printChart = (elementId) => {
    const printWindow = window.open("", "_blank")
    if (!printWindow) return

    const chartElement = document.getElementById(elementId)
    if (!chartElement) return

    const chartCanvas = chartElement.querySelector("canvas")
    if (!chartCanvas) return

    const chartImage = chartCanvas.toDataURL("image/png")

    printWindow.document.write(`
      <html>
        <head>
          <title>Imprimir Gráfica</title>
          <style>
            body { 
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
            }
            img { max-width: 100%; }
          </style>
        </head>
        <body>
          <img src="${chartImage}" />
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
      </html>
    `)

    printWindow.document.close()
  }

  // Formatear el rango de fechas para mostrar
  const getDateRangeText = () => {
    if (!dateRange.from) return ""

    if (dateRange.to && dateRange.from.getTime() !== dateRange.to.getTime()) {
      return `${format(dateRange.from, "dd/MM/yyyy")} - ${format(dateRange.to, "dd/MM/yyyy")}`
    }

    return format(dateRange.from, "dd/MM/yyyy")
  }

  // Crear elementos para los botones de acción de la gráfica
  const createChartActions = (type) => {
    const actions = [
      { title: "Descargar Excel", onClick: () => exportData(sampleData, type, "excel"), icon: <DownloadIcon /> },
      { title: "Descargar CSV", onClick: () => exportData(sampleData, type, "csv"), label: "CSV" },
      { title: "Guardar imagen", onClick: () => saveChartAsImage(type === "temperatura" ? "temperature-chart" : "humidity-chart", type), label: "PNG" },
      { title: "Imprimir", onClick: () => printChart(type === "temperatura" ? "temperature-chart" : "humidity-chart"), icon: <PrinterIcon /> }
    ]

    return (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {actions.map((action, index) => (
          <IconButton
            key={index}
            size="small"
            title={action.title}
            onClick={action.onClick}
            sx={{ border: '1px solid rgba(0, 0, 0, 0.12)', borderRadius: 1 }}
          >
            {action.icon || <Typography variant="caption" sx={{ fontWeight: 'bold' }}>{action.label}</Typography>}
          </IconButton>
        ))}
      </Box>
    )
  }

  // Crear tarjeta para la gráfica
  const createChartCard = (title, type, chart) => {
    return (
      <Card sx={{ mb: 2 }}>
        <CardHeader
          title={title}
          action={createChartActions(type)}
          titleTypographyProps={{ variant: 'h6' }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          <Box sx={{ p: 3, height: 300 }}>
            {chart}
          </Box>
        </CardContent>
      </Card>
    )
  }

  // Renderizar información del sensor
  const renderSensorInfo = () => {
    const infoItems = [
      // { icon: <InfoIcon fontSize="small" color="action" />, label: "ID:", value: sensor.id },
      // { icon: <MapPinIcon fontSize="small" color="action" />, label: "MAC:", value: sensor.mac },
      { icon: <ClockIcon fontSize="small" color="action" />, label: "Última actualización:", value: sensor.lastUpdate },
      { icon: <ThermometerIcon fontSize="small" color="error" />, label: "Temperatura actual:", value: `${(sampleData.temperature[sampleData.temperature.length - 1])/100}°C` },
      { icon: <DropletsIcon fontSize="small" color="primary" />, label: "Humedad actual:", value: `${sampleData.humidity[sampleData.humidity.length - 1]}%` },
    ]

    const infoItems2 = [
      { icon: <InfoIcon fontSize="small" color="action" />, label: "Serial:", value: sensor.serial },
      { icon: <InfoIcon fontSize="small" color="action" />, label: "Firmware:", value: sensor.firmwareVersion },
      { icon: <InfoIcon fontSize="small" color="action" />, label: "Estado:", value: sensor.status, chip: true }
    ]

    const createInfoItem = (item) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }} key={item.label}>
        {item.icon}
        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{item.label}</Typography>
        {item.chip ? (
          <Box component="span" sx={{
            fontSize: '0.875rem',
            bgcolor: 'success.light',
            color: 'success.dark',
            px: 1,
            py: 0.25,
            borderRadius: 10
          }}>
            {item.value}
          </Box>
        ) : (
          <Typography variant="body2">{item.value}</Typography>
        )}
      </Box>
    )

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {infoItems.map(createInfoItem)}
        </Grid>
        <Grid item xs={12} md={6}>
          {infoItems2.map(createInfoItem)}
        </Grid>
      </Grid>
    )
  }

  // Configuracion
  const renderSensorInfoConf = () => {
    const infoItems = [
      { icon: <InfoIcon fontSize="small" color="action" />, label: "User:", value: sensorConf.conexion },
    ]

    const infoItems2 = [
      { icon: <DropletsIcon fontSize="small" color="primary" />, label: "Password:", value: sensorConf.clave },
    ]

    const createInfoItem = (item) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }} key={item.label}>
        {item.icon}
        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{item.label}</Typography>
        {item.chip ? (
          <Box component="span" sx={{
            fontSize: '0.875rem',
            bgcolor: 'success.light',
            color: 'success.dark',
            px: 1,
            py: 0.25,
            borderRadius: 10
          }}>
            <Typography
              variant="body2"
              sx={{
                overflowWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'normal',
                maxWidth: '100%',
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ) : (
          <Typography
            variant="body2"
            sx={{
              overflowWrap: 'break-word',
              wordBreak: 'break-all',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}
          >
            {item.value}
          </Typography>
        )}
      </Box>
    )

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {infoItems.map(createInfoItem)}
        </Grid>
        <Grid item xs={12} md={6}>
          {infoItems2.map(createInfoItem)}
        </Grid>
      </Grid>
    )
  }

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', p: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Panel de Monitoreo Ambiental
      </Typography>

      {/* Controles de fecha */}
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Paper variant="outlined" sx={{ display: 'inline-flex', borderRadius: 1 }}>
              <Button
                variant={activeView === "daily" ? "contained" : "text"}
                onClick={() => handleViewChange("daily")}
                sx={{ borderRadius: '4px 0 0 4px' }}
              >
                Diario
              </Button>
              <Button
                variant={activeView === "weekly" ? "contained" : "text"}
                onClick={() => handleViewChange("weekly")}
              >
                Semanal
              </Button>
              <Button
                variant={activeView === "monthly" ? "contained" : "text"}
                onClick={() => handleViewChange("monthly")}
                sx={{ borderRadius: '0 4px 4px 0' }}
              >
                Mensual
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            {/*<CustomDateRangePicker
              dateRange={dateRange}
              onDateRangeChange={(range) => {
                setDateRange(range)
                setActiveView("custom")
              }}
            />*/}
          </Grid>
        </Grid>

        {activeView === "custom" && dateRange.from && dateRange.to && (
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mt: 1 }}>
            Mostrando datos personalizados: {getDateRangeText()}
          </Typography>
        )}
      </Box>

      {/* Contenido principal */}
      <Box sx={{ mb: 4 }}>
        {/* Tarjeta de información del sensor */}
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Información del Sensor" titleTypographyProps={{ variant: 'h6' }} />
          <CardContent>
            {renderSensorInfo()}
          </CardContent>
        </Card>

        {/* Tarjeta de configuración */}
        <Card sx={{ mb: 3 }}>
          <CardHeader title="Cadenas de configuración" titleTypographyProps={{ variant: 'h6' }} />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <InfoIcon fontSize="small" color="action" />
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>ID:</Typography>
                  {sensor.id}
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <InfoIcon fontSize="small" color="action" />
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>MAC:</Typography>
                  {sensor.mac}
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                {renderSensorInfoConf()}
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Tabs para las gráficas */}
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="chart tabs" centered>
              <Tab label="Ambos" />
              <Tab label="Temperatura" />
              <Tab label="Humedad" />
            </Tabs>
          </Box>

          {/* Contenido de ambas gráficas */}
          <Box hidden={tabValue !== 0} sx={{ mt: 2 }}>
            {createChartCard("Temperatura", "temperatura", <TemperatureChart data={sampleData} />)}
            {createChartCard("Humedad", "humedad", <HumidityChart data={sampleData} />)}
          </Box>

          {/* Contenido de temperatura */}
          <Box hidden={tabValue !== 1} sx={{ mt: 2 }}>
            {createChartCard("Temperatura", "temperatura", <TemperatureChart data={sampleData} />)}
          </Box>

          {/* Contenido de humedad */}
          <Box hidden={tabValue !== 2} sx={{ mt: 2 }}>
            {createChartCard("Humedad", "humedad", <HumidityChart data={sampleData} />)}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
